import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { locale as vn } from './i18n/vn';
import { locale as english } from './i18n/en';
import { BaseBasicDialog } from 'app/shared/dialog';

@Component({
    selector: 'app-switcher-dialog',
    templateUrl: 'app-switcher-dialog.component.html',
})

export class AppSwitcherDialogComponent {

    closeDialog(valueEmited: any): void {
        this.dialogRef.close();
    }

    constructor(
        public dialogRef: MatDialogRef<AppSwitcherDialogComponent>,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    ) {
        this._fuseTranslationLoaderService.loadTranslations(english, vn);
    }
}
